export function normalizeMime(mime?: string) {
    if (!mime) return "text/plain;charset=utf-8";

    const m = mime.toLowerCase().trim();

    // Plain text / fallback-y types
    if (m === "text" || m === "txt" || m === "plain") return "text/plain;charset=utf-8";
    if (m === "md" || m === "markdown") return "text/markdown;charset=utf-8";
    if (m === "csv") return "text/csv;charset=utf-8";

    // Web
    if (m === "javascript" || m === "js") return "text/javascript;charset=utf-8";
    if (m === "typescript" || m === "ts") return "text/plain;charset=utf-8"; // safest in browsers
    if (m === "json") return "application/json;charset=utf-8";
    if (m === "html" || m === "htm") return "text/html;charset=utf-8";
    if (m === "css") return "text/css;charset=utf-8";
    if (m === "xml") return "application/xml;charset=utf-8";
    if (m === "yaml" || m === "yml") return "application/yaml;charset=utf-8";

    // Programming languages (many of these are not universally standardized in browsers,
    // but these are common/recognized values; fallback to text/plain is always acceptable)
    if (m === "python" || m === "py") return "text/x-python;charset=utf-8";
    if (m === "java") return "text/x-java-source;charset=utf-8";
    if (m === "csharp" || m === "c#" || m === "cs") return "text/plain;charset=utf-8";
    if (m === "cpp" || m === "c++" || m === "cc" || m === "cxx") return "text/x-c++;charset=utf-8";
    if (m === "c") return "text/x-c;charset=utf-8";
    if (m === "go" || m === "golang") return "text/plain;charset=utf-8";
    if (m === "rust" || m === "rs") return "text/plain;charset=utf-8";
    if (m === "php") return "application/x-httpd-php;charset=utf-8";
    if (m === "ruby" || m === "rb") return "text/plain;charset=utf-8";
    if (m === "swift") return "text/plain;charset=utf-8";
    if (m === "kotlin" || m === "kt") return "text/plain;charset=utf-8";
    if (m === "scala") return "text/plain;charset=utf-8";
    if (m === "sql") return "application/sql;charset=utf-8";
    if (m === "sh" || m === "bash" || m === "shell") return "application/x-sh;charset=utf-8";

    // If caller already passed something like "text/plain" or "application/javascript",
    // keep it (and optionally allow them to include charset themselves)
    return mime;
}
